module.exports = __webpack_public_path__ + "img/pars.d89eda8.png";